import {Page} from '../types/Page';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class PagesService {
  public async getAllPages(): Promise<Page[]> {
    return handleError(
      () => httpClient.get<Page[]>('/pages'),
      'Error fetching pages:',
      () => []
    );
  }

  public async getPage(id: string): Promise<Page> {
    return handleError(
      () => httpClient.get<Page>(`/pages/${id}`),
      'Error fetching page:'
    );
  }

  public async getPageByAlias(alias: string): Promise<Page> {
    return handleError(
      () => httpClient.get<Page>(`/pages/alias/${alias}`),
      'Error fetching page by alias:'
    );
  }

  public async createPage(page: Omit<Page, 'id'>): Promise<void> {
    const pageWithId = {
      ...page,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/pages', pageWithId),
      'Error creating page:'
    );
  }

  public async updatePage(page: Page): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/pages/${page.id}`, page),
      'Error updating page:'
    );
  }

  public async deletePage(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/pages/${id}`),
      'Error deleting page:'
    );
  }
}

const pagesService = new PagesService();
export default pagesService;

